import { defineMessages } from 'react-intl';

export default defineMessages({
  newsFeed: {
    id: 'dashboard_auto.news_feed',
  },
  ignore: {
    id: 'dashboard_auto.ignore',
  },
});
